// Static fallback catalog data — loads instantly, no Supabase dependency
export const FALLBACK_CATEGORIES = [
  { id: 1, name: 'Активная акустика', slug: 'active-speakers' },
  { id: 2, name: 'Пассивная акустика', slug: 'passive-speakers' },
  { id: 3, name: 'Сабвуферы', slug: 'subwoofers' },
  { id: 4, name: 'Мониторы сцены', slug: 'stage-monitors' },
  { id: 5, name: 'Усилители мощности', slug: 'amplifiers' },
  { id: 6, name: 'Home Series', slug: 'home-series' },
]

const STORAGE = 'https://eajflygzslmidvnegpov.supabase.co/storage/v1/object/public'

// NOTE: Images deduplicated at render time
export const FALLBACK_PRODUCTS = [
  {
    id: 1, slug: 'ss-h8pro', sku: 'SS-H8PRO', name: 'H-Series 8″ Pro',
    category_id: 1,
    short_description: 'Активная двухполосная АС, 8"+1", 300Вт, макс SPL 126дБ',
    description: 'Компактная активная двухполосная акустическая система с 8" НЧ-динамиком и 1" ВЧ-компрессионным драйвером. Идеально для небольших мероприятий, караоке-клубов и конференц-залов.',
    price: 22800, specs: { power: '300Вт', spl: '126дБ', weight: '12кг', impedance: '8Ω', response: '65Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod-alpha/SS-H8PRO/SS-H8PRO.png`,
    images: [`${STORAGE}/prod-alpha/SS-H8PRO/SS-H8PRO.png`, `${STORAGE}/prod-alpha/SS-H8PRO/SS-H8PRO_1.png`],
    category: 'Активная акустика',
    retail_price: 22800, dealer_price: 15775, effectivePrice: 22800, isDealer: false,
  },
  {
    id: 2, slug: 'ss-da15s', sku: 'SS-DA15S', name: 'DA-15S',
    category_id: 3,
    short_description: 'Активный сабвуфер 15", 800Вт, макс SPL 135дБ',
    description: 'Активный сабвуфер с 15" НЧ-динамиком и встроенным усилителем класса D мощностью 800Вт. Для клубов, концертных площадок и event-мероприятий.',
    price: 71500, specs: { power: '800Вт', spl: '135дБ', weight: '38кг', impedance: '4Ω', response: '38Гц–150Гц' },
    is_active: true, cover_image: `${STORAGE}/prod-alpha/SS-DA15S/SS-DA15S.png`,
    images: [`${STORAGE}/prod-alpha/SS-DA15S/SS-DA15S.png`, `${STORAGE}/prod-alpha/SS-DA15S/SS-DA15S1.png`],
    category: 'Сабвуферы',
    retail_price: 71500, dealer_price: 49530, effectivePrice: 71500, isDealer: false,
  },
  {
    id: 3, slug: 'ss-da18s', sku: 'SS-DA18S', name: 'DA-18S',
    category_id: 3,
    short_description: 'Активный сабвуфер 18", 1200Вт, макс SPL 140дБ',
    description: 'Флагманский активный сабвуфер с 18" НЧ-динамиком и встроенным усилителем класса D мощностью 1200Вт. Максимальное давление звука для крупных мероприятий.',
    price: 84000, specs: { power: '1200Вт', spl: '140дБ', weight: '52кг', impedance: '4Ω', response: '32Гц–150Гц' },
    is_active: true, cover_image: `${STORAGE}/prod-alpha/SS-DA18S/SS-DA18S.png`,
    images: [`${STORAGE}/prod-alpha/SS-DA18S/SS-DA18S.png`, `${STORAGE}/prod-alpha/SS-DA18S/SS-DA18S1.png`],
    category: 'Сабвуферы',
    retail_price: 84000, dealer_price: 58240, effectivePrice: 84000, isDealer: false,
  },
  {
    id: 4, slug: 'ss-r10a', sku: 'SS-R10A', name: 'R-10A',
    category_id: 4,
    short_description: 'Активный сценический монитор 10", 200Вт',
    description: 'Компактный активный сценический монитор с 10" НЧ-динамиком. Идеален для сценического мониторинга и небольших выступлений.',
    price: 36800, specs: { power: '200Вт', spl: '122дБ', weight: '10кг', impedance: '8Ω', response: '70Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod3-alpha/SS-R10A/SS-10RA.png`,
    images: [`${STORAGE}/prod3-alpha/SS-R10A/SS-10RA.png`, `${STORAGE}/prod3-alpha/SS-R10A/SS-10RA_1.png`],
    category: 'Мониторы сцены',
    retail_price: 36800, dealer_price: 25512, effectivePrice: 36800, isDealer: false,
  },
  {
    id: 5, slug: 'ss-r12a', sku: 'SS-R12A', name: 'R-12A',
    category_id: 4,
    short_description: 'Активный сценический монитор 12", 300Вт',
    description: 'Активный сценический монитор с 12" НЧ-динамиком и 1" ВЧ-драйвером. Оптимальный выбор для средних сцен и event-мероприятий.',
    price: 45900, specs: { power: '300Вт', spl: '126дБ', weight: '14кг', impedance: '8Ω', response: '60Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod3-alpha/SS-R12A/SS-12RA.png`,
    images: [`${STORAGE}/prod3-alpha/SS-R12A/SS-12RA.png`, `${STORAGE}/prod3-alpha/SS-R12A/SS-12RA_1.png`],
    category: 'Мониторы сцены',
    retail_price: 45900, dealer_price: 31785, effectivePrice: 45900, isDealer: false,
  },
  {
    id: 6, slug: 'ss-r15a', sku: 'SS-R15A', name: 'R-15A',
    category_id: 4,
    short_description: 'Активный сценический монитор 15", 400Вт',
    description: 'Флагманский активный сценический монитор с 15" НЧ-динамиком. Максимальное качество звука для профессиональных выступлений.',
    price: 51700, specs: { power: '400Вт', spl: '129дБ', weight: '18кг', impedance: '8Ω', response: '50Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod4-alpha/SS-R15A/SS-15RA.png`,
    images: [`${STORAGE}/prod4-alpha/SS-R15A/SS-15RA.png`, `${STORAGE}/prod4-alpha/SS-R15A/SS-15RA1.png`],
    category: 'Мониторы сцены',
    retail_price: 51700, dealer_price: 35750, effectivePrice: 51700, isDealer: false,
  },
  {
    id: 7, slug: 'ss-j4015a', sku: 'SS-J4015A', name: 'J-4015A',
    category_id: 2,
    short_description: 'Пассивная АС 2×15"+1", 600Вт',
    description: 'Пассивная двухполосная акустическая система с двумя 15" НЧ-динамиками и 1" ВЧ-компрессионным драйвером. Для крупных мероприятий и концертных площадок.',
    price: 29600, specs: { power: '600Вт', spl: '133дБ', weight: '32кг', impedance: '4Ω', response: '40Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod2-alpha/SS-J4015A/SJ4015.png`,
    images: [`${STORAGE}/prod2-alpha/SS-J4015A/SJ4015.png`, `${STORAGE}/prod2-alpha/SS-J4015A/SJ4015_1.png`],
    category: 'Пассивная акустика',
    retail_price: 29600, dealer_price: 20475, effectivePrice: 29600, isDealer: false,
  },
  {
    id: 8, slug: 'ss-j4012a', sku: 'SS-J4012A', name: 'J-4012A',
    category_id: 2,
    short_description: 'Пассивная АС 2×12"+1", 400Вт',
    description: 'Пассивная двухполосная акустическая система с двумя 12" НЧ-динамиками и 1" ВЧ-компрессионным драйвером. Универсальное решение для клубов и event-мероприятий.',
    price: 26500, specs: { power: '400Вт', spl: '130дБ', weight: '26кг', impedance: '8Ω', response: '45Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod2-alpha/SS-J4012A/SJ4012.png`,
    images: [`${STORAGE}/prod2-alpha/SS-J4012A/SJ4012.png`, `${STORAGE}/prod2-alpha/SS-J4012A/SJ4012_1.png`],
    category: 'Пассивная акустика',
    retail_price: 26500, dealer_price: 18330, effectivePrice: 26500, isDealer: false,
  },
  {
    id: 9, slug: 'ss200m-uv', sku: 'SS200M-UV', name: 'SS-200M UV',
    category_id: 2,
    short_description: 'Пассивная АС 12"+1", 300Вт, UV-стойкое покрытие',
    description: 'Пассивная акустическая система с UV-стойким покрытием для уличных мероприятий и open-air площадок.',
    price: 39000, specs: { power: '300Вт', spl: '127дБ', weight: '16кг', impedance: '8Ω', response: '55Гц–18кГц' },
    is_active: true, cover_image: `${STORAGE}/prod4-alpha/SS200M-UV/ss200m-uv.png`,
    images: [`${STORAGE}/prod4-alpha/SS200M-UV/ss200m-uv.png`],
    category: 'Пассивная акустика',
    retail_price: 39000, dealer_price: 26950, effectivePrice: 39000, isDealer: false,
  },
  {
    id: 10, slug: 'ss-280a', sku: 'SS-280A', name: 'SS-280A',
    category_id: 5,
    short_description: 'Усилитель мощности 2×800Вт/4Ω',
    description: 'Двухканальный усилитель мощности класса H. 2×800Вт при 4Ω, 2×1200Вт при 2Ω. Для профессиональных звуковых систем.',
    price: 23800, specs: { power: '2×800Вт', spl: '-', weight: '12кг', impedance: '4Ω', response: '20Гц–20кГц' },
    is_active: true, cover_image: `${STORAGE}/prod4-alpha/SS-280A/ss-280a.png`,
    images: [`${STORAGE}/prod4-alpha/SS-280A/ss-280a.png`],
    category: 'Усилители мощности',
    retail_price: 23800, dealer_price: 16500, effectivePrice: 23800, isDealer: false,
  },
  {
    id: 11, slug: 'ss-pa-21', sku: 'SS-PA2.1', name: 'SS-PA 2.1',
    category_id: 6,
    short_description: 'Акустическая система 2.1 PA, 1000 Вт',
    description: 'Активная акустическая система SS-PA 2.1 формата 2.1 PA общей мощностью 1000 Вт. Комплект включает 12-дюймовый сабвуфер мощностью 300 Вт RMS на базе 3-канального усилительного модуля и две пассивные 8-дюймовые акустические системы по 200 Вт RMS каждая. Корпус сабвуфера выполнен из окрашенного МДФ, сателлитов — из ABS-пластика с деревянным покрытием.\n\nСистема поддерживает беспроводное соединение Bluetooth, функцию TWS для объединения двух комплектов в стереопару, а также встроенный MP3-плеер с цветным LCD-дисплеем. В комплект поставки входят 2 кабеля длиной 7 метров и 2 стойки-треноги высотой 1.5 метра.',
    price: 88800, specs: [
      { key: 'Мощность', value: '300Вт+2×200Вт' },
      { key: 'SPL', value: '-' },
      { key: 'Вес', value: '28кг' },
      { key: 'Импеданс', value: '4Ω' },
      { key: 'Частотный диапазон', value: '40Гц–20кГц' },
      { key: 'Сабвуфер', value: '12"' },
      { key: 'Сателлиты', value: '2×8"' },
      { key: 'Bluetooth', value: 'Да' },
      { key: 'TWS', value: 'Да' },
    ],
    is_active: true, cover_image: '/products/SS-PA_2.1.png',
    images: ['/products/SS-PA_2.1.png', '/products/SS-PA_2.1_1.png', '/products/SS-PA_2.1_2.png', '/products/SS-PA_2.1_3.png', '/products/SS-PA_2.1_4.png', '/products/SS-PA_2.1_5.png'],
    category: 'Home Series',
    retail_price: 88800, dealer_price: 57250, effectivePrice: 88800, isDealer: false,
  },
  {
    id: 12, slug: 'ss-dd1238a', sku: 'SS-DD1238A', name: 'SS-DD1238A',
    category_id: 6,
    short_description: 'Колонная акустическая система 12", 1500 Вт',
    description: 'Колонная акустическая система SS-DD1238A мощностью 1500 Вт с усилителем класса D и биампингом. Система включает 12-дюймовый сабвуфер с 60-унциевым магнитом и 3-дюймовой звуковой катушкой, а также 8 среднечастотных/высокочастотных динамиков по 3 дюйма каждый. Корпус сабвуфера выполнен из МДФ с профессиональной покраской, корпус полного диапазона — из ударопрочного пластика.\n\nСистема оснащена DSP-процессором с LCD-экраном, поддерживает Bluetooth, TWS и встроенный MP3-плеер. Программная мощность 1500 Вт, RMS мощность 450+300 Вт.',
    price: 65000, specs: [
      { key: 'Мощность', value: '450+300Вт RMS' },
      { key: 'SPL', value: '-' },
      { key: 'Вес', value: '30.5кг' },
      { key: 'Импеданс', value: '4Ω' },
      { key: 'Частотный диапазон', value: '45Гц–20кГц' },
      { key: 'Сабвуфер', value: '12"' },
      { key: 'Динамики', value: '8×3"' },
      { key: 'DSP', value: 'LCD' },
      { key: 'Bluetooth', value: 'Да' },
    ],
    is_active: true, cover_image: '/products/SS-DD1238A.png',
    images: ['/products/SS-DD1238A.png', '/products/SS-DD1238A_1.png'],
    category: 'Home Series',
    retail_price: 65000, dealer_price: 42250, effectivePrice: 65000, isDealer: false,
  },
]